import React from 'react';


const Separator = () => {
  return <hr className="custom-separator" />;
};

export default Separator;
